import React from "react";
import Sidebar from "../components/sidebar/Sidebar";
import Dashboard from "../components/dashboard/Dashboard";
import { useLocation } from "react-router-dom";

// DashboardPage component renders the dashboard interface with a sidebar and dashboard content.
// It receives an openDrawer prop to control the sidebar drawer and extracts user data from the location state.
const DashboardPage = ({ openDrawer }) => {
  // useLocation hook provides access to the location object, which contains the state passed through navigation.
  const location = useLocation();

  // UserData object extracts user-specific data from the location state for rendering and authentication purposes.
  const UserData = {
    roles: location.state?.roles, // User roles (e.g., admin, user)
    isAdmin: location.state?.isAdmin, // Boolean flag indicating if the user is an admin
    isAuthenticated: location.state?.isAuthenticated, // Boolean flag indicating if the user is authenticated
    refreshToken: location.state?.refreshToken, // Token used to refresh user session
    accessToken: location.state?.accessToken, // Token used for API requests
    userId: location.state?.userId, // Unique identifier for the user
    username: location.state?.username, // Username of the authenticated user
  };

  return (
    <>
      {/* Sidebar component with openDrawer and userData props. 
          The 'active' prop indicates the active menu item in the sidebar (1 in this case). */}
      <Sidebar openDrawer={openDrawer} userData={UserData} active={1} />

      {/* Dashboard component that renders the main dashboard content. 
          It also receives the openDrawer prop to control the sidebar drawer. */}
      <Dashboard openDrawer={openDrawer} />
    </>
  );
};

export default DashboardPage;
